import React, { useEffect, useState } from 'react';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import { LABELS } from '../../constants';
import { hostUrlConverter, imgUrlConverter, sliderSettings } from '../../util';
import { ProductCard } from './components';

const GradGroupsAndProducts = React.memo(({
    altImage,
    pageContent,
    promoCodes,
    scrollPosition,
    shopAllUrl,
    tileData,
    googleAnalytics
}) => {
    const [shopAllLink, setShopAllLink] = useState("")
    const [productTileData, setProductTileData] = useState([]);

    useEffect(() => {
        const pathParams = window.location.pathname?.split("/")
        const shopAllRelatedProductsURL = hostUrlConverter(
            shopAllUrl
                ? shopAllUrl
                : pathParams?.length > 0 && `/apps/store/productBrowse/${pathParams[4]}/${pathParams[5]}/Graduation/${pathParams[7]}/CATALOG_REPOSITORY/CARDS/`
        )
        setShopAllLink(shopAllRelatedProductsURL)

        let saleProductsData = tileData?.map((productObj) => {
            if (productObj?.products?.length > 0) {
                let promoProduct = promoCodes?.find(o => productObj?.products[0].prodRefCode == o.prodRefCode);
                if (promoProduct != undefined) {
                    productObj.products[0].promoText = promoProduct.promoText
                }
                return productObj
            }
            else {
                let promoProduct = promoCodes?.find(o => productObj.prodRefCode == o.prodRefCode);
                if (promoProduct) {
                    productObj.promoText = promoProduct.promoText
                }
                return productObj
            }

        })
        if(saleProductsData?.length > 6){
            saleProductsData.splice(5, 0, {
                "shopAllUrl": shopAllRelatedProductsURL,
                "actionUrl": tileData?.actionUrl,
                "imageUrl": saleProductsData[0]?.imageUrl,
                "altImageText": "shopAllButton-"+saleProductsData[0]?.displayName
            })
        }
        setProductTileData(saleProductsData)
    }, [shopAllUrl, tileData])

    const handleProductCardClick = (actionUrl, shopAllUrl) => async () => {
        if (window?.jostensGaTracking?.gaEventsSpecPromise) {
            await Promise.all([window.jostensGaTracking.gaEventsSpecPromise])
        }
        window.location.assign(hostUrlConverter(actionUrl ?? shopAllUrl))
    }

    if (productTileData?.length > 0) {
        const productCardInitialProps = {
            handleImageError: (e) => (e.target.src = altImage),
            handleSeeDetailsClick: async () => {
                if (window?.jostensGaTracking?.gaEventsSpecPromise) {
                    await Promise.all([window.jostensGaTracking.gaEventsSpecPromise])
                }
                window.location.assign(hostUrlConverter(shopAllUrl))
            },
            scrollPosition
        }

        return (
            <div className="product-categories">
                <div className="mt-3 container-fluid">
                    <div>
                        <span className="h6 pr-2">{pageContent?.title}</span>
                        <a href={shopAllLink} 
                            className="jos-ga-tracking-element fa-xs"
                            data-jos-ga-tracking={JSON.stringify({
                                _resolveFields: {
                                    businessUnit: { 
                                        catalogOsr: googleAnalytics?.catalogOSR, 
                                        customerClassCode: googleAnalytics?.customerClassCode
                                    },
                                    productLine: { 
                                        catalogOsr: googleAnalytics?.catalogOSR 
                                    }
                                },
                                clickText: `${LABELS.SHOP_ALL}`, 
                                modalType: '', 
                                itemName: tileData?.displayName, 
                                actionType: 'button_click', 
                                categoryName: pageContent?.title || tileData?.displayName || 'Graduation Groups and Products'
                            })}
                        >{LABELS.SHOP_ALL}</a>
                    </div>
                    <hr />
                    <Slider {...sliderSettings(productTileData?.length)} className="carousel">
                        {productTileData?.map((productObj, index) => {
                            const shouldShowSeeDetails = index === 5 && productTileData?.length > 6
                            const actionUrl = productObj?.products?.[0]?.actionUrl

                            const productCardProps = productObj?.products?.length > 0 
                            ? {
                                ...productCardInitialProps,
                                handleProductClick: handleProductCardClick(actionUrl, productObj?.shopAllUrl),
                                handleProductNameClick: () => handleProductCardClick(actionUrl, productObj?.shopAllUrl),
                                imageAlt: productObj?.products[0]?.displayName,
                                imageSrc: shouldShowSeeDetails
                                    ? imgUrlConverter(productTileData[0].imageUrl || altImage)
                                    : imgUrlConverter(productObj?.products[0]?.imageUrl || altImage),
                                index,
                                priceComponentData: productObj?.products[0],
                                productName: productObj?.products[0]?.displayName,
                                promoMessage: productObj?.products[0]?.promoText,
                                shouldDisplayPrice: productObj?.products[0] && Object.keys(productObj?.products[0])?.length > 0,
                                shouldShowSeeDetails,
                                googleAnalytics,
                                sectionTitle: pageContent?.title || tileData?.displayName || 'Graduation Groups and Products'
                            }
                            : {
                                ...productCardInitialProps,
                                handleProductClick: handleProductCardClick(productObj?.actionUrl, productObj?.shopAllUrl),
                                handleProductNameClick: handleProductCardClick(productObj?.actionUrl, productObj?.shopAllUrl),
                                imageAlt: productObj?.displayName,
                                imageSrc: imgUrlConverter(productObj?.imageUrl || altImage),
                                index,
                                priceComponentData: productObj,
                                productName: productObj?.displayName,
                                promoMessage: productObj?.promoText,
                                shouldDisplayPrice: productObj && Object.keys(productObj)?.length > 0,
                                shouldShowSeeDetails,
                                googleAnalytics,
                                sectionTitle: pageContent?.title || tileData?.displayName || 'Graduation Groups and Products'
                            }

                            return <ProductCard {...productCardProps} />
                        })}

                    </Slider>
                </div>
            </div>)
    } else {
        return null
    }
})

export default trackWindowScroll(GradGroupsAndProducts)